export const showSuccessToast = () => window.showToast?.(window?.toastMessages?.copyLinkSuccess, 'success');
export const showErrorToast = () => window.showToast?.(window?.toastMessages?.copyLinkError, 'error');
